import { createContext } from "react";
import { FilterBody } from "../../../../../hooks/filter/typing";


export interface OptionGroupContextType {
  filterMain: FilterBody;
}

export const OptionGroupContext = createContext<OptionGroupContextType>(
  {} as OptionGroupContextType
);